/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export const tableWrapper = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
`

export const toolbarLeft = css`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`

export const searchInput = css`
  width: 280px;
`

export const categoryFilter = css`
  width: 200px;
`

export const tableContainer = css`
  overflow-x: auto;
  overflow-y: visible;
`

export const headerCell = css`
  min-width: 120px;
`

export const emptyRow = css`
  padding: 48px 0;
  text-align: center;
`
